import { Button } from '@/ui/button/button';
import { WithDropdownContent } from '@/ui/dropdown/with-dropdown-content';
import { useTranslation } from 'react-i18next';
import { AskX } from './ask-x';
import { styled } from 'goober';
import { showAskXResultState } from './asx-x.state';
import { PRODUCT } from '@/user/products/product.type';
import { useUserProducts } from '@/user/products/use-user-products';
import { useSetAtom } from 'jotai';

export const AskXButton = () => {
  const { t } = useTranslation('askX');
  const setResultState = useSetAtom(showAskXResultState);
  const resetResultState = () => setResultState(false);

  const { hasRequiredProduct } = useUserProducts();
  if (!hasRequiredProduct(PRODUCT.ASK_X)) return null;

  return (
    <WithDropdownContent
      content={close => (
        <Wrapper>
          <AskX
            onClose={() => {
              close();
              resetResultState();
            }}
          />
        </Wrapper>
      )}
      onClose={() => {
        resetResultState();
      }}
      options={{
        placement: 'bottom-start',
        modifiers: [{ name: 'offset', options: { offset: [-320, 14] } }],
      }}
    >
      <Button variant="black" startIcon="LightBulb">{t`actionTitle`}</Button>
    </WithDropdownContent>
  );
};

const Wrapper = styled('div')`
  background-color: ${({ theme }) => theme.colors.basics.black};
  color: ${({ theme }) => theme.colors.basics.white};
  padding: 32px;
  border-radius: 20px;
  width: 500px;

  .header {
    color: ${({ theme }) => theme.colors.basics.white};
  }
`;
